import { useEffect } from 'react';
import { Layout as AntLayout } from 'antd';
import { useLocation } from 'react-router-dom';
import styles from './style.module.scss';
import Footer from '../footer';
import Sidebar from './sidebar';
import Header from './header';
import classNames from 'classnames';
import useShops from 'hooks/useShops';
import { getPendingRequestState } from 'hooks/useApi';
import { useRecoilValue } from 'recoil';
import { saveListSearch } from 'helpers/listSearchStorage';

const { Content } = AntLayout;

const Layout = ({ children, hideLayout, hideSideBar }) => {
  const { inProgress } = useRecoilValue(getPendingRequestState);
  const { pathname, search } = useLocation();
  useShops();

  // Remember filters of every page to restore them when coming back
  useEffect(() => {
    saveListSearch(pathname, search);
  }, [pathname, search]);

  if (hideLayout) {
    return children;
  }

  return (
    <AntLayout hasSider className={inProgress && styles.sitePendingRequest}>
      {!hideLayout && !hideSideBar && <Sidebar />}
      <AntLayout
        className={classNames(
          styles.siteLayout,
          (hideLayout || hideSideBar) && styles.siteLayoutHide,
        )}
      >
        {!hideLayout && <Header fullWidth={hideSideBar} />}
        <Content
          className={classNames(
            styles.content,
            hideLayout && styles.contentHide,
          )}
        >
          <div>{children}</div>
          <Footer />
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
